import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, Popper, Paper, List, ListItemButton, ListItemText, ListItemIcon, ClickAwayListener, Box, Typography, Avatar, IconButton, Badge } from '@mui/material';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import PersonTwoToneIcon from '@mui/icons-material/PersonTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import MeetingRoomTwoToneIcon from '@mui/icons-material/MeetingRoomTwoTone';
import NotificationsIcon from '@mui/icons-material/Notifications';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import DescriptionIcon from '@mui/icons-material/Description';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { useNavigate } from 'react-router-dom';

const ProfileSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [userData, setUserData] = React.useState(null);
  const anchorRef = React.useRef(null);

  // Get user data from localStorage
  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUserData(decoded);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    if (index === 1) {
      navigate('/profile'); 
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleLogout = () => {
    // Remove the token from localStorage
    localStorage.removeItem('token');
  
    // Auto-refresh the page
    window.location.reload();
  
    // Redirect to login page
    navigate('/application/login');
  };  

  return (
    <>
      {/* Icons sebelah kiri */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
        <IconButton color="inherit">
          <DescriptionIcon />
        </IconButton>
        <IconButton color="inherit">
          <FullscreenIcon />
        </IconButton>
        <IconButton color="inherit">
          <QrCodeScannerIcon />
        </IconButton>
        <IconButton color="inherit">
          <Badge badgeContent={5} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Box>

      {/* User Info with Profile Dropdown */}
      <Button
        sx={{ 
          minWidth: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1,
          textTransform: 'none',
          color: 'inherit'
        }}
        ref={anchorRef} 
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-label="Profile"
        onClick={handleToggle}
      >
        <Avatar 
          src={userData?.profile_url} 
          sx={{ width: 36, height: 36 }}
        />
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="body2" sx={{ 
            fontSize: '0.9rem', 
            lineHeight: 1.2, 
            fontWeight: 500,
            color: 'white'
          }}>
            {userData?.nama_lengkap || 'Samuel Ir. Soekarno'}
          </Typography>
          <Typography variant="caption" sx={{ 
            fontSize: '0.8rem', 
            color: 'rgba(255, 255, 255, 0.8)',
            fontWeight: 500
          }}>
            {userData?.nik || 'P3101'}
          </Typography>
        </Box>
      </Button>
      
      {/* Popper untuk dropdown */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 14], 
            },
          },
        ]}
        style={{ zIndex: theme.zIndex.modal }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper>
            <List sx={{ width: 250, bgcolor: theme.palette.background.paper }}>
              <ListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
                <ListItemIcon>
                  <SettingsTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItemButton>
              <ListItemButton selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
                <ListItemIcon>
                  <PersonTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Profile" />
              </ListItemButton>
              <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
                <ListItemIcon>
                  <MeetingRoomTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItemButton>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default ProfileSection;
